var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tab-filter"},_vm._l((_vm.items),function(item){return _c('li',{key:item.value,staticClass:"tab-filter__item",class:{'tab-filter__item--active': _vm.activeItem === item},on:{"click":function($event){return _vm.onChange(item)}}},[_vm._v("\n    "+_vm._s(item.text)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }